import styled from "styled-components";
import { FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
export const TooltipContent = styled.div.withConfig({
    displayName: "styled__TooltipContent",
    componentId: "sc-4f7a253d-0"
})`
	color: ${({ theme  })=>theme.colors.white.base};
	${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'base'
})}
	max-width: 142px;
	text-align: left;
	p {
		margin-bottom: 4px;
	}
	p:last-of-type {
		color: ${({ theme  })=>theme.colors.grays.light};
		margin-bottom: 0;
	}
`;

//# sourceMappingURL=styled.js.map